"use strict";

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.object.keys.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es7.object.get-own-property-descriptors.js");

require("core-js/modules/es6.object.assign.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.array.from.js");

require("core-js/modules/es6.array.slice.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Typeahead = exports.DatePicker = exports.InputGroup = exports.RadioGroup = exports.Radio = exports.ErrorNotice = exports.Label = exports.Input = exports.formatHTTPS = exports.parsePhone = exports.stdErrMsg = exports.checkboxRequired = exports.isUniquePhone = exports.doesMatch = exports.isMinLength = exports.isFourDigitPIN = exports.isSimpleURL = exports.isValidZip = exports.isValidPhone = exports.isEmailNonRequired = exports.isEmail = exports.isFullUrl = exports.isUrl = exports.isRequired = exports.Errors = exports.Control = exports.Field = exports.Form = exports.formActions = void 0;

require("core-js/modules/es6.string.includes.js");

require("core-js/modules/es7.array.includes.js");

require("core-js/modules/es6.regexp.replace.js");

require("core-js/modules/es6.array.find-index.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.regexp.to-string.js");

require("core-js/modules/es6.regexp.split.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es6.number.is-finite.js");

require("core-js/modules/es6.number.constructor.js");

require("core-js/modules/es6.string.small.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.array.map.js");

require("core-js/modules/es6.regexp.constructor.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.array.fill.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _validator = _interopRequireDefault(require("validator"));

var _classnames = _interopRequireDefault(require("classnames"));

var _titleCase = _interopRequireDefault(require("title-case"));

var _libphonenumberJs = require("libphonenumber-js");

var _timesArray = require("@evdy/web-redux/dist/constants/timesArray");

var _dates = require("@evdy/web-redux/dist/constants/dash/dates");

var _utils = require("../../lib/utils");

var _reactRedux = require("react-redux");

var _reactReduxForm = require("react-redux-form");

var _dec, _class, _class2, _temp, _dec2, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Export RRF Aliases
 */
var formActions = _reactReduxForm.actions;
exports.formActions = formActions;
var Form = _reactReduxForm.Form;
exports.Form = Form;
var Field = _reactReduxForm.Field;
exports.Field = Field;
var Control = _reactReduxForm.Control;
exports.Control = Control;
var Errors = _reactReduxForm.Errors;
exports.Errors = Errors;

var isRequired = function isRequired(val) {
  return !_validator.default.isEmpty((val + '').trim());
};

exports.isRequired = isRequired;

var isUrl = function isUrl(val) {
  return !isRequired(val) || _validator.default.isURL(val + '');
};

exports.isUrl = isUrl;

var isFullUrl = function isFullUrl(val) {
  return !isRequired(val) || _validator.default.isURL(val + '', {
    protocols: ['http', 'https'],
    require_protocol: true
  });
};

exports.isFullUrl = isFullUrl;

var isEmail = function isEmail(val) {
  return !isRequired(val) || _validator.default.isEmail(val + '');
};

exports.isEmail = isEmail;

var isEmailNonRequired = function isEmailNonRequired(val) {
  return !val || _validator.default.isEmail(val + '');
};

exports.isEmailNonRequired = isEmailNonRequired;

var isValidPhone = function isValidPhone(val) {
  if (!val) return true;
  return !isRequired(val) || (0, _libphonenumberJs.isValidNumber)(val, 'US') || (0, _libphonenumberJs.isValidNumber)(val, 'CA');
};

exports.isValidPhone = isValidPhone;

var isValidZip = function isValidZip(val) {
  return !isRequired(val) || !!(0, _utils.getZipLocation)(val).length;
};

exports.isValidZip = isValidZip;

var isSimpleURL = function isSimpleURL(val) {
  return !isRequired(val) || val.includes('.');
};

exports.isSimpleURL = isSimpleURL;

var isFourDigitPIN = function isFourDigitPIN(val) {
  return !isRequired(val) || val.length === 4;
};

exports.isFourDigitPIN = isFourDigitPIN;

var isMinLength = function isMinLength(min) {
  return function (val) {
    if (typeof val === 'undefined') return false;
    return !isRequired(val) || val.length >= min;
  };
};

exports.isMinLength = isMinLength;

var doesMatch = function doesMatch(val) {
  return function (toMatchValue) {
    return !isRequired(val) || val === toMatchValue;
  };
};

exports.doesMatch = doesMatch;

var isUniquePhone = function isUniquePhone() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    isUniquePhone: function isUniquePhone() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!val || !val.replace) return true;
      var num = parseInt(val.replace(/[()\- ]/g, ''));
      return list.findIndex(function (m) {
        return m.phone === num;
      }) < 0;
    }
  };
};

exports.isUniquePhone = isUniquePhone;

var checkboxRequired = function checkboxRequired(val) {
  return val;
};

exports.checkboxRequired = checkboxRequired;

var stdErrMsg = function stdErrMsg(title) {
  return {
    isRequired: "".concat(title, " is required")
  };
};

exports.stdErrMsg = stdErrMsg;

var parsePhone = function parsePhone(val) {
  if (/^\(?\d{0,3}\)?$/.test(val)) return val;

  try {
    // noinspection JSPotentiallyInvalidConstructorUsage
    return new _libphonenumberJs.asYouType('US').input(val.toString());
  } catch (_) {
    return val;
  }
};

exports.parsePhone = parsePhone;

var formatHTTPS = function formatHTTPS(val) {
  var url = val.split(/https?:\/\//).pop() || '';
  return "https://".concat(url);
};

exports.formatHTTPS = formatHTTPS;

require('../../sass/components/shared/Input.css');

var inputPin = require('../../images/input-pin.svg');

var inputClock = require('../../images/input-clock.svg');

var inputSearch = require('../../images/input-search.svg');

var customClass = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array, _propTypes.default.object]);

var isLong = function isLong(value) {
  return value.length > 5;
};

var isTime = function isTime(value) {
  return value ? /\b((1[0-2]|0?[1-9]):([0-5][0-9])([AaPp][Mm]))/.test(value) : true;
};

var formatSearch = function formatSearch(query, time) {
  if (time) query = query.replace(/^0+/, '');
  if (!query || typeof query !== 'string') return;
  return query.replace(/[^\w\s]/g, '').trim().toLowerCase().split(' ').filter(function (x) {
    return x !== '';
  }).join('');
};

var makeSaveString = function makeSaveString(model) {
  var displayIdx = model.indexOf('.display');
  return displayIdx > -1 ? model.substring(0, displayIdx) : '';
};

var testOnSelect = function testOnSelect(param) {
  console.log(param);
  return function (originalItem) {
    //will return as item or, if saveKey was defined, as an array [item, saveValue]
    console.log(originalItem);
  };
};

var truthyOrFinite = function truthyOrFinite(x) {
  return !!x || Number.isFinite(x);
};

var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input() {
    _classCallCheck(this, Input);

    return _super.apply(this, arguments);
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          full = _this$props.full,
          mini = _this$props.mini,
          small = _this$props.small,
          medium = _this$props.medium,
          inline = _this$props.inline,
          pre = _this$props.pre,
          post = _this$props.post,
          rows = _this$props.rows,
          customClass = _this$props.customClass,
          rest = _objectWithoutProperties(_this$props, ["type", "full", "mini", "small", "medium", "inline", "pre", "post", "rows", "customClass"]);

      var className = function className(_ref) {
        var _ref$fieldValue = _ref.fieldValue,
            value = _ref$fieldValue.value,
            focus = _ref$fieldValue.focus;
        return (0, _classnames.default)('ev-control', customClass, {
          full: full,
          mini: mini,
          small: small,
          medium: medium,
          inline: inline,
          pre: !!pre,
          post: !!post,
          'ev-control-select': type === 'select',
          'ev-control-checkbox': type === 'checkbox',
          'ev-control-textarea': type === 'textarea',
          'ev-control-blank': !truthyOrFinite(value) && !focus
        });
      };

      var mapProps = {
        className: className
      };

      var combinedProps = _objectSpread(_objectSpread({}, rest), {}, {
        mapProps: mapProps,
        type: type
      });

      switch (type) {
        case 'select':
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "select-wrapper"
          }, /*#__PURE__*/_react.default.createElement(Control.select, combinedProps));

        case 'checkbox':
          return /*#__PURE__*/_react.default.createElement(Control.checkbox, combinedProps);

        case 'textarea':
          return /*#__PURE__*/_react.default.createElement(Control.textarea, _objectSpread(_objectSpread({}, combinedProps), {}, {
            rows: rows
          }));

        default:
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "ev-control-wrapper"
          }, pre && /*#__PURE__*/_react.default.createElement("img", {
            className: "ev-control-pre",
            src: pre
          }), /*#__PURE__*/_react.default.createElement(Control, combinedProps), post && /*#__PURE__*/_react.default.createElement("img", {
            className: "ev-control-post",
            src: post
          }));
      }
    }
  }]);

  return Input;
}(_react.default.Component);

exports.Input = Input;
Input.propTypes = {
  customClass: customClass,
  model: _propTypes.default.string,
  pre: _propTypes.default.string,
  post: _propTypes.default.string,
  rows: _propTypes.default.string,
  full: _propTypes.default.bool,
  mini: _propTypes.default.bool,
  small: _propTypes.default.bool,
  medium: _propTypes.default.bool,
  inline: _propTypes.default.bool
};

var Label = /*#__PURE__*/function (_React$Component2) {
  _inherits(Label, _React$Component2);

  var _super2 = _createSuper(Label);

  function Label() {
    _classCallCheck(this, Label);

    return _super2.apply(this, arguments);
  }

  _createClass(Label, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          customClass = _this$props2.customClass,
          rest = _objectWithoutProperties(_this$props2, ["children", "customClass"]);

      var labelClass = (0, _classnames.default)('ev-label', customClass);
      return /*#__PURE__*/_react.default.createElement("label", _extends({
        className: labelClass
      }, rest), children);
    }
  }]);

  return Label;
}(_react.default.Component);

exports.Label = Label;
Label.propTypes = {
  customClass: customClass
};

var ErrorNotice = /*#__PURE__*/function (_React$Component3) {
  _inherits(ErrorNotice, _React$Component3);

  var _super3 = _createSuper(ErrorNotice);

  function ErrorNotice() {
    _classCallCheck(this, ErrorNotice);

    return _super3.apply(this, arguments);
  }

  _createClass(ErrorNotice, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          customClass = _this$props3.customClass,
          rest = _objectWithoutProperties(_this$props3, ["customClass"]);

      var errorsClass = (0, _classnames.default)('ev-input-errors', customClass);
      return /*#__PURE__*/_react.default.createElement(Errors, _extends({
        className: errorsClass
      }, rest));
    }
  }]);

  return ErrorNotice;
}(_react.default.Component);

exports.ErrorNotice = ErrorNotice;
ErrorNotice.propTypes = {
  customClass: customClass,
  show: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.func]),
  messages: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]))
};
ErrorNotice.defaultProps = {
  show: function show(f) {
    return f.touched && !f.focus;
  }
};

var Radio = function Radio(props, key) {
  var value, labelText, img;

  if (typeof props === 'string') {
    value = props;
  } else if (Array.isArray(props)) {
    value = props[0];
    labelText = props[1];
  } else if (props !== null && _typeof(props) === 'object') {
    value = props.value;
    labelText = props.labelText;
    img = props.image;
  } else {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("label", {
    key: key,
    className: 'ev-label ev-label-radio'
  }, img && /*#__PURE__*/_react.default.createElement("img", {
    src: img,
    alt: "img-for-".concat(labelText)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ev-label-text"
  }, labelText || (0, _titleCase.default)(value)), /*#__PURE__*/_react.default.createElement("input", {
    className: "ev-control-radio",
    type: "radio",
    value: value
  }));
};

exports.Radio = Radio;

var RadioGroup = /*#__PURE__*/function (_React$Component4) {
  _inherits(RadioGroup, _React$Component4);

  var _super4 = _createSuper(RadioGroup);

  function RadioGroup() {
    _classCallCheck(this, RadioGroup);

    return _super4.apply(this, arguments);
  }

  _createClass(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          model = _this$props4.model,
          labelText = _this$props4.labelText,
          showErrorNotice = _this$props4.showErrorNotice,
          messages = _this$props4.messages,
          block = _this$props4.block,
          customClass = _this$props4.customClass,
          values = _this$props4.values,
          id = _this$props4.id,
          rest = _objectWithoutProperties(_this$props4, ["model", "labelText", "showErrorNotice", "messages", "block", "customClass", "values", "id"]);

      var outerClass = (0, _classnames.default)('ev-input-group ev-radio-group', customClass, {
        'ev-radio-group-block': block
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: outerClass
      }, labelText && /*#__PURE__*/_react.default.createElement(Label, {
        htmlFor: model
      }, labelText), /*#__PURE__*/_react.default.createElement(Field, _extends({}, _objectSpread({
        model: model
      }, rest), {
        id: id || model
      }), values.map(Radio)), /*#__PURE__*/_react.default.createElement(ErrorNotice, {
        model: model,
        messages: messages,
        show: showErrorNotice
      }));
    }
  }]);

  return RadioGroup;
}(_react.default.Component);

exports.RadioGroup = RadioGroup;
RadioGroup.propTypes = {
  customClass: customClass,
  model: _propTypes.default.string.isRequired,
  labelText: _propTypes.default.string,
  block: _propTypes.default.bool,
  messages: ErrorNotice.propTypes.messages,
  showErrorNotice: ErrorNotice.propTypes.show
};

var InputGroup = /*#__PURE__*/function (_React$Component5) {
  _inherits(InputGroup, _React$Component5);

  var _super5 = _createSuper(InputGroup);

  function InputGroup() {
    _classCallCheck(this, InputGroup);

    return _super5.apply(this, arguments);
  }

  _createClass(InputGroup, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props5 = this.props,
          model = _this$props5.model,
          labelText = _this$props5.labelText,
          showErrorNotice = _this$props5.showErrorNotice,
          messages = _this$props5.messages,
          single = _this$props5.single,
          customClass = _this$props5.customClass,
          customInputClass = _this$props5.customInputClass,
          customLabelClass = _this$props5.customLabelClass,
          customErrorsClass = _this$props5.customErrorsClass,
          children = _this$props5.children,
          strongerID = _this$props5.strongerID,
          rest = _objectWithoutProperties(_this$props5, ["model", "labelText", "showErrorNotice", "messages", "single", "customClass", "customInputClass", "customLabelClass", "customErrorsClass", "children", "strongerID"]);

      var outerClass = (0, _classnames.default)('ev-input-group', customClass, {
        single: single,
        full: rest.full,
        mini: rest.mini,
        small: rest.small,
        medium: rest.medium,
        inline: rest.inline,
        'ev-select-group': rest.type === 'select',
        'ev-checkbox-group': rest.type === 'checkbox'
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: outerClass
      }, labelText && /*#__PURE__*/_react.default.createElement(Label, {
        htmlFor: strongerID || model,
        customClass: customLabelClass
      }, labelText), /*#__PURE__*/_react.default.createElement(Input, _extends({}, _objectSpread({
        model: model
      }, rest), {
        id: strongerID || model,
        ref: function ref(el) {
          return _this.input = el;
        },
        customClass: customInputClass
      }), children), /*#__PURE__*/_react.default.createElement(ErrorNotice, {
        model: model,
        messages: messages,
        show: showErrorNotice,
        customClass: customErrorsClass
      }));
    }
  }]);

  return InputGroup;
}(_react.default.Component);

exports.InputGroup = InputGroup;
InputGroup.propTypes = {
  model: _propTypes.default.string.isRequired,
  type: _propTypes.default.string,
  labelText: _propTypes.default.string,
  validators: _propTypes.default.objectOf(_propTypes.default.func),
  strongerID: _propTypes.default.string,
  messages: ErrorNotice.propTypes.messages,
  showErrorNotice: ErrorNotice.propTypes.show,
  full: _propTypes.default.bool,
  mini: _propTypes.default.bool,
  small: _propTypes.default.bool,
  medium: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  single: _propTypes.default.bool,
  customClass: customClass,
  customInputClass: customClass,
  customLabelClass: customClass,
  customErrorsClass: customClass
};
InputGroup.defaultProps = {
  type: 'text'
};

var DatePicker = /*#__PURE__*/function (_React$Component6) {
  _inherits(DatePicker, _React$Component6);

  var _super6 = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this2;

    _classCallCheck(this, DatePicker);

    _this2 = _super6.call(this, props);
    _this2.state = {
      dayRange: props.defaultDayRange,
      yearRange: props.defaultYearRange
    };
    _this2.inputs = {};
    _this2.fullModel = "".concat(props.model, ".").concat(props.dateModel);
    var currentDate = new Date();
    _this2.today = {
      day: currentDate.getDate(),
      month: currentDate.getMonth(),
      year: currentDate.getFullYear()
    };
    _this2.date = {
      month: '',
      day: '',
      year: ''
    };
    _this2.handleMonthUpdate = _this2.handleUpdate(_this2.handleMonthUpdate.bind(_assertThisInitialized(_this2)));
    _this2.handleYearUpdate = _this2.handleUpdate(_this2.handleYearUpdate.bind(_assertThisInitialized(_this2)));
    _this2.showError = _this2.showError.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(DatePicker, [{
    key: "handleUpdate",
    value: function handleUpdate(fn) {
      return function (val) {
        fn(val);
        return val;
      };
    }
  }, {
    key: "updateDayRange",
    value: function updateDayRange() {
      var dayMax = this.props.dayMax;
      this.setState({
        dayRange: dayMax || (0, _dates.getDayRange)(this.date)
      });
    }
  }, {
    key: "handleMonthUpdate",
    value: function handleMonthUpdate(val) {
      this.date.month = val;
      this.updateDayRange();
    }
  }, {
    key: "handleYearUpdate",
    value: function handleYearUpdate(val) {
      var _this$props6 = this.props,
          dateMin = _this$props6.dateMin,
          noFuture = _this$props6.noFuture,
          yearBase = _this$props6.yearBase;
      this.date.year = val;
      this.updateDayRange();

      if (dateMin && dateMin.year && noFuture) {
        this.setState({
          yearRange: (yearBase || this.today.year) - val + 1
        });
      }
    }
  }, {
    key: "showError",
    value: function showError(f) {
      var _this$props7 = this.props,
          dateModel = _this$props7.dateModel,
          untouchedErrors = _this$props7.untouchedErrors;
      if (!f.touched && !untouchedErrors) return;
      return !RegExp("".concat(dateModel, "\\.(?:month|day|year)$")).test(document.activeElement ? document.activeElement.name : '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props8 = this.props,
          label = _this$props8.label,
          isRequired = _this$props8.isRequired,
          monthMin = _this$props8.monthMin,
          monthMax = _this$props8.monthMax,
          dayMin = _this$props8.dayMin,
          yearBase = _this$props8.yearBase,
          messages = _this$props8.messages,
          validators = _this$props8.validators;
      var _this$state = this.state,
          dayRange = _this$state.dayRange,
          yearRange = _this$state.yearRange;
      var days = new Array(dayRange).fill('');
      var years = new Array(yearRange).fill('');
      var requiredValidator = isRequired ? DatePicker.isRequired : function () {
        return true;
      };
      return /*#__PURE__*/_react.default.createElement(Form, {
        model: this.fullModel,
        component: "div",
        className: "ev-date-group-with-error inline",
        validators: {
          '': _objectSpread({
            isRequired: requiredValidator,
            dateComplete: DatePicker.dateComplete
          }, validators)
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ev-date-group"
      }, /*#__PURE__*/_react.default.createElement(InputGroup, {
        small: true,
        inline: true,
        type: "select",
        model: ".month",
        labelText: label,
        parser: this.handleMonthUpdate
      }, /*#__PURE__*/_react.default.createElement("option", {
        value: ""
      }, "Month"), _dates.months.map(function (month, idx) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: idx,
          value: idx,
          disabled: monthMin && monthMin > idx || monthMax && monthMax < idx
        }, month);
      })), /*#__PURE__*/_react.default.createElement(InputGroup, {
        mini: true,
        inline: true,
        type: "select",
        model: ".day",
        parser: this.handleDayUpdate
      }, /*#__PURE__*/_react.default.createElement("option", {
        value: ""
      }, "Day"), days.map(function (el, idx) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: idx,
          value: idx + 1,
          disabled: dayMin && dayMin > idx + 1
        }, idx + 1);
      })), /*#__PURE__*/_react.default.createElement(InputGroup, {
        mini: true,
        inline: true,
        type: "select",
        model: ".year",
        parser: this.handleYearUpdate
      }, /*#__PURE__*/_react.default.createElement("option", {
        value: ""
      }, "Year"), years.map(function (el, idx) {
        var year = (yearBase || _this3.today.year) - idx;
        return /*#__PURE__*/_react.default.createElement("option", {
          key: idx,
          value: year
        }, year);
      }))), /*#__PURE__*/_react.default.createElement(ErrorNotice, {
        show: this.showError,
        model: this.fullModel,
        messages: _objectSpread(_objectSpread({
          dateComplete: 'Incomplete date'
        }, stdErrMsg('Date')), messages)
      }));
    }
  }], [{
    key: "getTruthyCount",
    value: function getTruthyCount() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          day = _ref2.day,
          month = _ref2.month,
          year = _ref2.year;

      return [day, month, year].map(truthyOrFinite).filter(Boolean).length;
    }
  }, {
    key: "dateComplete",
    value: function dateComplete(date) {
      var dirty = DatePicker.getTruthyCount(date);
      return dirty === 3 || dirty === 0;
    }
  }, {
    key: "isRequired",
    value: function isRequired(date) {
      return DatePicker.getTruthyCount(date) === 3;
    }
  }]);

  return DatePicker;
}(_react.default.Component);

exports.DatePicker = DatePicker;
DatePicker.propTypes = {
  model: _propTypes.default.string.isRequired,
  dateModel: _propTypes.default.string,
  label: _propTypes.default.string,
  dateMin: _propTypes.default.number,
  dateMax: _propTypes.default.number,
  yearBase: _propTypes.default.number,
  defaultDayRange: _propTypes.default.number,
  defaultYearRange: _propTypes.default.number,
  noFuture: _propTypes.default.bool,
  isRequired: _propTypes.default.bool,
  untouchedErrors: _propTypes.default.bool,
  messages: _propTypes.default.objectOf(_propTypes.default.string),
  validators: _propTypes.default.objectOf(_propTypes.default.func)
};
DatePicker.defaultProps = {
  dateModel: 'date',
  label: 'Date',
  yearBase: null,
  defaultDayRange: 31,
  defaultYearRange: 120
};
var centerStyle = {
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column'
};
var moodData = ['happy', 'annoyed', 'unruly', 'rolypolled', 'hungry', 'hoppity', 'too excited to pick a mood', 'full of yearning'];
var piesDataObjects = [{
  type: 'peach',
  id: 1
}, {
  type: 'plum',
  id: 2
}, {
  type: 'pecan (ew)',
  id: 3
}, {
  type: 'blewburry',
  id: 4
}, {
  type: 'all berry',
  id: 5
}, {
  type: 'apple aka bad',
  id: 6
}, {
  type: 'RHUBARB!!',
  id: 6.5
}, {
  type: 'chicken pot why is this called pie',
  id: 7
}];
var Typeahead = (_dec = (0, _reactRedux.connect)(null, null, null, {
  forwardRef: true
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component7) {
  _inherits(Typeahead, _React$Component7);

  var _super7 = _createSuper(Typeahead);

  //TODO: move the below comment to static propTypes
  // If your typeahead is accepting an array of objects, you must format the corresponding field
  // in your reducer as an object with a key for 'display' and a key for 'save' such as:
  // pie : { display: '', save: ''}
  function Typeahead(props) {
    var _this4;

    _classCallCheck(this, Typeahead);

    _this4 = _super7.call(this, props);

    _this4.changeFocus = function (isFocused) {
      _this4.setState({
        isFocused: isFocused
      }, function () {
        _this4.moveDefaultItemToTop();
      });
    };

    _this4.listItemOnClick = function (_item, oItem, model, modelBase) {
      var onSelect = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var saveKey = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var _this4$props = _this4.props,
          jsxKeys = _this4$props.jsxKeys,
          dispatch = _this4$props.dispatch;
      var item = _item[0] || _item;
      var saveKeyValue = _item[2] || false;
      var modelString = "".concat(modelBase).concat(model);

      if (jsxKeys) {
        dispatch(_reactReduxForm.actions.change(modelString, _item[1]));
      } else {
        dispatch(_reactReduxForm.actions.change(modelString, item));
      }

      if (saveKey) {
        var removeDisplay = makeSaveString(model);
        dispatch(_reactReduxForm.actions.change("".concat(modelBase).concat(removeDisplay, ".save"), saveKeyValue));
      }

      var originalItemOrMutated = oItem[0] && oItem[0].props ? oItem[0] : item;
      onSelect && onSelect(saveKeyValue ? [item, saveKeyValue] : originalItemOrMutated);

      _this4.setState({
        autoSelected: false
      });

      _this4.changeFocus();
    };

    _this4.listItem = function (limit) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      return function (item, idx) {
        var _this4$props2 = _this4.props,
            jsxKeys = _this4$props2.jsxKeys,
            model = _this4$props2.model;

        var _item = jsxKeys ? [jsxKeys[idx].displayKey, jsxKeys[idx].saveKey] : item;

        if (limit && idx > limit) return null;
        var active = _this4.state.activeItem === idx;

        if (_this4.state.activeItem === idx) {
          //saved to this bc cannot save to state during render
          _this4.activeProps = [_item, item].concat(rest);
        }

        return /*#__PURE__*/_react.default.createElement("li", {
          key: "".concat(model, "-").concat(idx),
          className: active ? 'active' : null,
          ref: function ref(el) {
            return active ? _this4.activeListItem = el : null;
          },
          onClick: function onClick() {
            var _this5;

            (_this5 = _this4).listItemOnClick.apply(_this5, [_item, item].concat(rest));
          }
        }, item[0]);
      };
    };

    _this4.state = {
      isFocused: false,
      activeItem: -1,
      autoSelected: false
    };
    _this4.changeFocus = _this4.changeFocus.bind(_assertThisInitialized(_this4));
    _this4.listItemOnClick = _this4.listItemOnClick.bind(_assertThisInitialized(_this4));
    _this4.keyboardScroll = _this4.keyboardScroll.bind(_assertThisInitialized(_this4));
    _this4.listItem = _this4.listItem.bind(_assertThisInitialized(_this4));
    _this4.setValue = _this4.setValue.bind(_assertThisInitialized(_this4));
    _this4.typeaheadOnChange = _this4.typeaheadOnChange.bind(_assertThisInitialized(_this4));
    return _this4;
  }

  _createClass(Typeahead, [{
    key: "keyboardScroll",
    value: function keyboardScroll(e) {
      var isFocused = this.state.isFocused;
      var activeItem = this.state.activeItem;

      if (isFocused && (e.keyCode === 38 || e.keyCode === 40)) {
        var listLength = this.list && this.list.childElementCount;

        if (activeItem < 0 && e.keyCode === 40) {
          activeItem = 0;
        } else {
          if (e.keyCode === 40) {
            activeItem += 1;
          } else {
            activeItem -= 1;
          }

          if (this.props.time) {
            var activeChild = this.list && this.list.children[activeItem];
            activeChild && activeChild.scrollIntoView(true);
          }

          if (activeItem < 0 || activeItem >= listLength) {
            activeItem = -1;
          }
        }

        this.setState({
          activeItem: activeItem,
          autoSelected: false
        });
      } else if (isFocused && (e.keyCode === 13 || e.keyCode === 9) && this.activeListItem && this.activeProps) {
        if (e.keyCode === 9 && this.state.autoSelected) return;
        this.listItemOnClick.apply(this, _toConsumableArray(this.activeProps));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.keyboardScroll, false);
    }
  }, {
    key: "moveDefaultItemToTop",
    value: function moveDefaultItemToTop() {
      if (this.props.time && !this.state.value) {
        this.setState({
          activeItem: 24,
          autoSelected: true
        });
        this.list.children[24].scrollIntoView(true);
      }
    }
  }, {
    key: "setValue",
    value: function setValue(model, modelBase, saveKey) {
      var _this6 = this;

      return function (e) {
        if (!e || !e.target) return e;
        var value = e.target.value;

        _this6.setState({
          value: value
        });

        if (saveKey && value === '') {
          var removeDisplay = makeSaveString(model);

          _this6.props.dispatch(_reactReduxForm.actions.change("".concat(modelBase).concat(removeDisplay, ".save"), ''));
        }

        return e;
      };
    }
  }, {
    key: "typeaheadOnChange",
    value: function typeaheadOnChange(isFocused, onChange, e) {
      if (!isFocused) {
        this.changeFocus(true);
      }

      onChange && onChange(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var _this$props9 = this.props,
          time = _this$props9.time,
          data = _this$props9.data,
          pre = _this$props9.pre,
          _this$props9$limit = _this$props9.limit,
          limit = _this$props9$limit === void 0 ? 10 : _this$props9$limit,
          saveKey = _this$props9.saveKey,
          displayKey = _this$props9.displayKey,
          jsxKeys = _this$props9.jsxKeys,
          model = _this$props9.model,
          modelBase = _this$props9.modelBase,
          onSelect = _this$props9.onSelect,
          _onChange = _this$props9.onChange,
          validators = _this$props9.validators,
          messages = _this$props9.messages,
          filterIdx = _this$props9.filterIdx,
          anyWord = _this$props9.anyWord,
          showUnfilteredResults = _this$props9.showUnfilteredResults,
          showUnfilteredAtFirst = _this$props9.showUnfilteredAtFirst,
          keepResultsOpen = _this$props9.keepResultsOpen,
          rest = _objectWithoutProperties(_this$props9, ["time", "data", "pre", "limit", "saveKey", "displayKey", "jsxKeys", "model", "modelBase", "onSelect", "onChange", "validators", "messages", "filterIdx", "anyWord", "showUnfilteredResults", "showUnfilteredAtFirst", "keepResultsOpen"]);

      var _this$state2 = this.state,
          value = _this$state2.value,
          isFocused = _this$state2.isFocused;
      var typeaheadClasses = (0, _classnames.default)('ev-typeahead', {
        closed: keepResultsOpen ? false : !isFocused || value && !isFocused,
        full: rest.full,
        mini: rest.mini,
        small: rest.small,
        medium: rest.medium,
        inline: rest.inline
      });
      var typeaheadValue = value || '';
      var regexTest = new RegExp("".concat(anyWord ? '' : '^').concat(formatSearch(typeaheadValue, time)));
      var formattedData = [];

      if (time) {
        formattedData = _timesArray.timeArray.map(function (item) {
          return [item, formatSearch(item)];
        });
      } else if (typeof data[0] === 'string') {
        formattedData = data.map(function (item) {
          return [item, formatSearch(item)];
        });
      } else if (_typeof(data[0]) === 'object' && data[0].props && data[0].props.children && jsxKeys) {
        //if passing a react element, include an [object] with `displayKey` and `saveKey` for each element
        formattedData = data.map(function (item, idx) {
          var searchText = jsxKeys[idx].displayKey;
          return [item, formatSearch(searchText)];
        });
      } else if (_typeof(data[0]) === 'object' && displayKey && saveKey) {
        formattedData = data.map(function (item) {
          return [item[displayKey], formatSearch(item[displayKey]), item[saveKey]];
        });
      } else if (_typeof(data[0]) === 'object') {
        throw new Error('If using an array of objects, must define displayKey and saveKey, or if using a React Element must define jsxKeys');
      }

      var filteredData = formattedData.filter(function (item) {
        return regexTest.test(item[1]);
      });
      var list = showUnfilteredAtFirst && !value || time && !value || showUnfilteredResults ? formattedData.map(this.listItem(false, model, modelBase, onSelect, saveKey)) : filteredData.map(this.listItem(limit, model, modelBase, onSelect, saveKey));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: typeaheadClasses,
        onFocus: function onFocus() {
          return _this7.changeFocus(true);
        },
        onBlur: function onBlur() {
          return window.setTimeout(_this7.changeFocus, 200);
        },
        ref: function ref(el) {
          return _this7.container = el;
        }
      }, /*#__PURE__*/_react.default.createElement(InputGroup, _extends({}, _objectSpread({
        model: model
      }, rest), {
        pre: time ? inputClock : pre || null,
        getValue: this.setValue(model, modelBase, saveKey),
        onChange: function onChange(e) {
          return e.charCode !== 13 && _this7.typeaheadOnChange(isFocused, _onChange, e);
        },
        autoComplete: "off",
        validators: _objectSpread({
          isTime: time ? isTime : function () {
            return true;
          }
        }, validators),
        messages: _objectSpread({
          isTime: time ? 'Invalid time' : null
        }, messages)
      })), /*#__PURE__*/_react.default.createElement("ul", {
        className: "ev-typeahead-results",
        ref: function ref(el) {
          return _this7.list = el;
        }
      }, list));
    }
  }]);

  return Typeahead;
}(_react.default.Component), _class2.propTypes = {
  data: _propTypes.default.any,
  dispatch: _propTypes.default.any,
  displayKey: _propTypes.default.any,
  inline: _propTypes.default.any,
  limit: _propTypes.default.number,
  messages: _propTypes.default.any,
  model: _propTypes.default.string.isRequired,
  modelBase: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.any,
  onSelect: _propTypes.default.any,
  pre: _propTypes.default.any,
  saveKey: _propTypes.default.any,
  time: _propTypes.default.bool,
  validators: _propTypes.default.any
}, _class2.defaultProps = {
  limit: 10,
  time: false
}, _temp)) || _class);
exports.Typeahead = Typeahead;
var TestInput = (_dec2 = (0, _reactRedux.connect)(function (_ref3) {
  var sample = _ref3.sample;
  return {
    sample: sample
  };
}), _dec2(_class3 = /*#__PURE__*/function (_React$Component8) {
  _inherits(TestInput, _React$Component8);

  var _super8 = _createSuper(TestInput);

  function TestInput() {
    _classCallCheck(this, TestInput);

    return _super8.apply(this, arguments);
  }

  _createClass(TestInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.classList.add('announcement-creation-stepper');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove('announcement-creation-stepper');
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: centerStyle
      }, /*#__PURE__*/_react.default.createElement(Form, {
        model: "forms.sample"
      }, /*#__PURE__*/_react.default.createElement(InputGroup, {
        model: ".name",
        labelText: "Name",
        validators: {
          isRequired: isRequired,
          isLong: isLong
        },
        messages: {
          isRequired: 'Name is required',
          isLong: 'Name has to be really long'
        }
      }), /*#__PURE__*/_react.default.createElement(InputGroup, {
        model: ".age",
        type: "number",
        labelText: "Age",
        validators: {
          isRequired: isRequired,
          overEighteen: function overEighteen(v) {
            return v > 17;
          }
        },
        messages: {
          isRequired: 'Age is required',
          overEighteen: 'Must be over eighteen'
        }
      }), /*#__PURE__*/_react.default.createElement(RadioGroup, {
        model: ".cereal",
        values: ['powerUps', ['oat', 'Oat Bran'], {
          value: 'crispix',
          labelText: 'Crispix'
        }],
        labelText: "Cereal"
      }), /*#__PURE__*/_react.default.createElement(RadioGroup, {
        block: true,
        model: ".petType",
        values: ['sparkleBird', ['dog', 'Dawg'], {
          value: 'cat',
          labelText: 'Kittie'
        }],
        labelText: "Pet Type (Block)"
      }), /*#__PURE__*/_react.default.createElement(InputGroup, {
        model: ".hairColor",
        labelText: "Hair Color",
        type: "select"
      }, /*#__PURE__*/_react.default.createElement("option", null), /*#__PURE__*/_react.default.createElement("option", {
        value: "black"
      }, "Black"), /*#__PURE__*/_react.default.createElement("option", {
        value: "brown"
      }, "Brown"), /*#__PURE__*/_react.default.createElement("option", {
        value: "red"
      }, "Red"), /*#__PURE__*/_react.default.createElement("option", {
        value: "blonde"
      }, "Blonde"), /*#__PURE__*/_react.default.createElement("option", {
        value: "other"
      }, "Other")), /*#__PURE__*/_react.default.createElement(InputGroup, {
        model: ".isCold",
        labelText: "Is it Cold?",
        type: "checkbox"
      }), /*#__PURE__*/_react.default.createElement(InputGroup, {
        model: ".notes",
        labelText: "Notes",
        type: "textarea"
      }), /*#__PURE__*/_react.default.createElement(InputGroup, {
        full: true,
        post: inputClock,
        model: ".full",
        labelText: "Full Post"
      }), /*#__PURE__*/_react.default.createElement(InputGroup, {
        mini: true,
        inline: true,
        model: ".mini",
        labelText: "Mini Post"
      }), /*#__PURE__*/_react.default.createElement(InputGroup, {
        small: true,
        post: inputPin,
        inline: true,
        model: ".small",
        labelText: "Small Post"
      }), /*#__PURE__*/_react.default.createElement(InputGroup, {
        pre: inputSearch,
        model: ".custom",
        labelText: "Custom Classes",
        customClass: "twist-group",
        customInputClass: "purple-input",
        customLabelClass: "purple-label",
        customErrorsClass: "purple-error",
        validators: {
          isRequired: isRequired
        },
        messages: {
          isRequired: 'Purple is best'
        }
      }), /*#__PURE__*/_react.default.createElement(Typeahead, {
        model: ".pie.display",
        modelBase: "forms.sample",
        labelText: "Start typing a pie",
        data: piesDataObjects,
        displayKey: "type",
        saveKey: "id"
      }), /*#__PURE__*/_react.default.createElement(Typeahead, {
        model: ".mood",
        modelBase: "forms.sample",
        labelText: "Start typing a mood",
        data: moodData,
        limit: 2
      }), /*#__PURE__*/_react.default.createElement(Typeahead, {
        time: true,
        model: ".time",
        modelBase: "forms.sample",
        labelText: "Pick a time",
        onSelect: function onSelect(e) {
          return testOnSelect('scorpion power')(e);
        }
      })));
    }
  }]);

  return TestInput;
}(_react.default.Component)) || _class3);
exports.default = TestInput;